const DEFAULT_WIDTH = 480;
const DEFAULT_HEIGHT = 350;

export { DEFAULT_HEIGHT, DEFAULT_WIDTH };
